module.exports = {
	methods: {
		prepare: function(){
			this.model.disabled = false;
			this.model.isFilterField = false;
			if((this.formMapping  || {}).fieldConfig) {
				this.model.disabled        = Boolean(this.formMapping.fieldConfig.disabled);
				this.model.isFilterField   = Boolean(this.formMapping.fieldConfig.isFilterField);
			}

			this.model.config = this.model.config || {};
			this.model.disabled |= this.model.config.disabled;
		}
	}
};